import React, { useState, useEffect, useContext } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid'


export default function MapFooter(props) {

    const useStyles = makeStyles({

        root: {
            display:"flex",
            flexDirection:"row",
            width: props.width,
            height:25,
            backgroundColor: '#FFFFFF',
            color: '#000',
            zindex: 100,
        },

      });

  const classes = useStyles();

  return (
    <div id='footer' className={classes.root}>
        <Grid container>
            <Grid item xs={5}></Grid>
            <Grid item xs={3}>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><Box p={1} fontSize={12}>{process.env.REACT_APP_MAP_COPYRIGHT}</Box></Grid>
        </Grid>
    </div>
  );
}